import axios from 'axios';
import endpointNames from "../configs/serverUrls";

//url variable
const baseUrl = endpointNames.policies;
let token = JSON.parse(localStorage.getItem('token'));
let user = JSON.parse(localStorage.getItem('user'));


const getAllPolicies = async () => {
    let response;
    await axios.get(baseUrl.getAll, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            if (res.status === 200) {
                console.log(res);
                response = res;
            }
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;

}

const searchPolicy = async (policyNumber) => {
    let response
    await axios.get(baseUrl.search + policyNumber, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            if (res.status === 200) {
                console.log(res);
                response = res;
            }
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const getPolicy = async (policyId) => {
    let response
    await axios.get(baseUrl.get_policy + policyId, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            if (res.status === 200) {
                console.log(res);
                response = res;
            }
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

//get accident
const getAllAccidents = async () => {
    let response;
    await axios.get(baseUrl.accident, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            if (res.status === 200) {
                console.log(res);
                response = res.data;
            }

        })
        .catch(err => {
            console.log(err);
            response = [];
        });
    return response;

}


//get comprehensive
const getAllComprehensive = async () => {
    let response;
    await axios.get(baseUrl.comprehensive, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            if (res.status === 200) {
                console.log(res);
                response = res.data;
            }
        })
        .catch(err => {
            console.log(err);
            response = [];
        });
    return response;

}
//get funeral
const getAllFuneral = async () => {
    let response;
    await axios.get(baseUrl.funeral, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            if (res.status === 200) {
                console.log(res);
                response = res.data;
            }
        })
        .catch(err => {
            console.log(err);
            response = [];
        });
    return response;

}
//get savings
const getAllSavings = async () => {
    let response;
    await axios.get(baseUrl.funeral, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            if (res.status === 200) {
                console.log(res);
                response = res.data;
            }
        })
        .catch(err => {
            console.log(err);
            response = [];
        });
    return response;

}

const updatePolicy = async (req) => {
    let response;
    let u = JSON.parse(localStorage.getItem('user'));
    let request = {...req, "user_id": u.id}
    await axios.put(baseUrl.update + req.id, request, {
        headers: {Authorization: `Bearer ${token}`}
    }).then(res => {
        console.log("response: " + res);
        response = res;
    }).catch(err => {
        console.log("err: " + err)
        response = err;
    })
    return response;
}

const deletePolicy = async (id) => {
    let response;

    await axios.post(baseUrl.delete + id, user, {
        headers: {Authorization: `Bearer ${token}`}
    }).then(res => {
        console.log("response: " + res);
        response = res;
    }).catch(err => {
        console.log("err: " + err)
        response = err;
    })
    return response;
}

const alterations = async (request) => {
    let response;

    await axios.post(baseUrl.alterations, request, {
        headers: {Authorization: `Bearer ${token}`}
    }).then(res => {
        console.log("response: " + res);
        response = res;
    }).catch(err => {
        console.log("err: " + err)
        response = err;
    })
    return response;
}

export default {
    getAllAccidents,
    getAllFuneral,
    getAllSavings,
    getAllComprehensive,
    updatePolicy,
    getAllPolicies,
    searchPolicy,
    deletePolicy,
    alterations,
    getPolicy
}
